'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reservationStatusChanged = exports.requestReservation = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.doTrackReservation = doTrackReservation;
exports.doReserveClass = doReserveClass;
exports.watchRequestReservation = watchRequestReservation;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _multitrack = require('helpers/multitrack');

var _localStorage = require('redux/saga/helpers/local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doTrackReservation),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doReserveClass),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchRequestReservation);

var REQUEST_RESERVATION = 'Reservation/REQUEST_RESERVATION';
var RESERVATION_STATUS_CHANGED = 'Reservation/RESERVATION_STATUS_CHANGED';

var requestReservation = exports.requestReservation = function requestReservation(scheduleId, venueId) {
  var reservationParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var trackingParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    type: REQUEST_RESERVATION,
    scheduleId: scheduleId,
    venueId: venueId,
    reservationParams: reservationParams,
    trackingParams: trackingParams
  };
};
var reservationStatusChanged = exports.reservationStatusChanged = function reservationStatusChanged() {
  return { type: RESERVATION_STATUS_CHANGED };
};

function doTrackReservation(scheduleId) {
  var reservationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var params = arguments[2];
  var trackingParams;
  return _regenerator2.default.wrap(function doTrackReservation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = _extends3.default;
          _context.t1 = {
            url: window.location.pathname,
            schedule_id: scheduleId,
            reservation_id: reservationId,
            failed: false,
            top_up: false,
            top_up_price: null,
            top_up_credit_amount: null
          };
          _context.next = 4;
          return (0, _effects.call)(_localStorage.readSessionStorage, 'schedule_' + scheduleId, {});

        case 4:
          _context.t2 = _context.sent;
          _context.t3 = params;
          trackingParams = (0, _context.t0)(_context.t1, _context.t2, _context.t3);
          _context.next = 9;
          return (0, _effects.call)(_multitrack.ec, 'Reserve Class', trackingParams);

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doReserveClass(client, _ref) {
  var scheduleId = _ref.scheduleId,
      venueId = _ref.venueId,
      reservationParams = _ref.reservationParams,
      trackingParams = _ref.trackingParams;
  var user, params, reservation;
  return _regenerator2.default.wrap(function doReserveClass$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 3:
          user = _context2.sent;
          params = (0, _extends3.default)({
            schedule: scheduleId
          }, reservationParams);
          _context2.next = 7;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.createReservation, [client, user.id, params]);

        case 7:
          reservation = _context2.sent;
          _context2.next = 10;
          return (0, _effects.all)([(0, _effects.put)(reservationStatusChanged()), (0, _effects.call)(doTrackReservation, scheduleId, reservation.id, trackingParams), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.similarVenues, [client, venueId]), (0, _effects.call)(_sagaTools.fetchEntity, _bound.userCreditBalance, [client, user.id])]);

        case 10:
          _context2.next = 16;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 16;
          return (0, _effects.call)(doTrackReservation, scheduleId, undefined, (0, _extends3.default)({}, trackingParams, {
            failed: true
          }));

        case 16:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 12]]);
}

function watchRequestReservation(client) {
  return _regenerator2.default.wrap(function watchRequestReservation$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, REQUEST_RESERVATION, doReserveClass, client);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}